var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header',{attrs:{"active":_vm.$route.params.id ? '' : 'recipes'}}),_c('v-container',{staticClass:"d-lg-flex",attrs:{"id":"main"}},[_c('ListRecipes',{staticClass:"listRecipes"}),(_vm.selected && _vm.selected.id_recipe)?_c('RecipeContent',{attrs:{"id":"recipeContent"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }